export const ALLIANZ_UAT_API_BASE_URL = 'https://api-services.uat.1placedessaisons.com/uatm' as const

export const ALLIANZ_PROD_API_BASE_URL = 'https://api.allianz-trade.com' as const

export const ALLIANZ_OAUTH_PATH = '/v1/idp/oauth2/authorize' as const

export const ALLIANZ_ADVANCED_SEARCH_PATH = '/search/v2/companies/advancedSearch' as const

export const ALLIANZ_UAT_ADVANCED_SEARCH_PATH = '/search/uatm-v2/companies/advancedSearch' as const

export function allianzAdvancedSearchUrl(apiBaseUrl: string): string {
  const origin = new URL(apiBaseUrl).origin
  const path =
    origin === new URL(ALLIANZ_UAT_API_BASE_URL).origin
      ? ALLIANZ_UAT_ADVANCED_SEARCH_PATH
      : ALLIANZ_ADVANCED_SEARCH_PATH
  return `${origin}${path}`
}

export const ALLIANZ_PAGINATION_DEFAULTS = { page: 1, pageSize: 10 } as const
export const ALLIANZ_MAX_PAGE_SIZE = 50

export const ALLIANZ_DEFAULT_PAGE_SIZE = 25
export const ALLIANZ_MAX_SEARCH_PAGE_SIZE = 50

export const ALLIANZ_COMPANY_STATUS_CODES = ['A', 'P', 'C'] as const

export const ALLIANZ_COVERS_PATH = '/riskinfo/v3/covers' as const

export const ALLIANZ_COVERS_SEARCH_PATH = '/riskinfo/v3/covers/search' as const

export const ALLIANZ_REQUEST_TYPE_PRIMARY = 'Primary' as const

export const ALLIANZ_REQUEST_TYPE_CODES = [
  ALLIANZ_REQUEST_TYPE_PRIMARY,
  'Cap',
  'CapPlus',
  'CapOrCapPlus',
  'PreCheck',
  'PreCheckCap',
  'PreCheckCapPlus',
  'PreCheckCapOrCapPlus',
  'PreCheckGradeCover',
  'PreCheckGradePolicyCoverBasic',
  'PreCheckGradePolicyCoverDeluxe',
  'GradePolicyCoverBasic',
  'GradePolicyCoverDeluxe',
  'GradeCover'
] as const

export type AllianzRequestTypeCode = (typeof ALLIANZ_REQUEST_TYPE_CODES)[number]

export const ALLIANZ_COVER_REQUESTS_SEARCH_PATH = '/riskinfo/v3/coverRequests/search' as const

export const ALLIANZ_COVER_REQUEST_STATUS_CODES = [
  'Answered',
  'InProgress',
  'Rejected',
  'Cancelled',
  'Abandoned',
  'AwaitingUserValidation',
  'Terminated',
  'Undefined'
] as const

export const ALLIANZ_COVER_REQUEST_OPEN_STATUS_CODES = ['InProgress', 'AwaitingUserValidation'] as const

export function isAllianzCoverRequestOpen(status: string | undefined): boolean {
  return status != null && (ALLIANZ_COVER_REQUEST_OPEN_STATUS_CODES as readonly string[]).includes(status)
}

export const ALLIANZ_COMPANY_GRADES_PATH = '/riskinfo/v3/companyGrades' as const

export const ALLIANZ_CREDIT_REFRESH_DELAY_MS = 1000

export const ALLIANZ_CREDIT_REFRESH_STALE_HOURS = 12

export const ALLIANZ_COVER_POLL_BASE_DELAY_SECONDS = 60
export const ALLIANZ_COVER_POLL_MAX_DELAY_SECONDS = 6 * 60 * 60
export const ALLIANZ_COVER_POLL_MAX_ATTEMPTS = 24

export function allianzCoverPollDelaySeconds(attempt: number): number {
  const doublings = Math.min(Math.max(attempt, 0), 16)
  return Math.min(ALLIANZ_COVER_POLL_MAX_DELAY_SECONDS, ALLIANZ_COVER_POLL_BASE_DELAY_SECONDS * 2 ** doublings)
}

export const ALLIANZ_TOKEN_REFRESH_SKEW_MS = 5 * 60 * 1000

export const ALLIANZ_ID_TYPE_DUNS = 'DUN' as const
export const ALLIANZ_ID_TYPE_LEI = 'LEI' as const
export const ALLIANZ_ID_TYPE_EIN = 'EIN' as const
export const ALLIANZ_ID_TYPE_FEIN = 'FEIN' as const
export const ALLIANZ_ID_TYPE_VAT = 'VAT' as const

export const ALLIANZ_GOVERNMENT_ID_TYPE_CODES = [
  ALLIANZ_ID_TYPE_DUNS,
  ALLIANZ_ID_TYPE_LEI,
  ALLIANZ_ID_TYPE_EIN,
  ALLIANZ_ID_TYPE_VAT
] as const

export const ALLIANZ_GOVERNMENT_ID_TYPES = [
  { idTypeCode: ALLIANZ_ID_TYPE_DUNS, label: 'DUNS' },
  { idTypeCode: ALLIANZ_ID_TYPE_LEI, label: 'LEI' },
  { idTypeCode: ALLIANZ_ID_TYPE_EIN, label: 'EIN / FEIN' },
  { idTypeCode: ALLIANZ_ID_TYPE_VAT, label: 'VAT Number' }
] as const

export type AllianzGovernmentIdTypeCode = (typeof ALLIANZ_GOVERNMENT_ID_TYPE_CODES)[number]
